export default "__VITE_ASSET__6992b8b1__"